import { render, staticRenderFns } from "./BotImageMessage.vue?vue&type=template&id=d55d35e6&scoped=true"
import script from "./BotImageMessage.vue?vue&type=script&lang=js"
export * from "./BotImageMessage.vue?vue&type=script&lang=js"
import style0 from "./BotImageMessage.vue?vue&type=style&index=0&id=d55d35e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55d35e6",
  null
  
)

export default component.exports